/*
    MetricError.tsx -- A component for rendering the error for a Metric that failed to poll successfully.
*/

import type { JSX } from 'react';

import { Button } from 'Components/Buttons/Buttons';
import { Modal } from 'Components/Modal/Modal';
import { Text } from 'Components/Text/Text';
import { ICON_CLOSE } from 'Config/Icons';
import { MetricResponse } from 'Models/ExternalIntegrations';

import styles from './Metric.module.css';

export interface MetricErrorProps {
    hideModal: () => void;
    metric: MetricResponse;
}

export const MetricError = (props: MetricErrorProps): JSX.Element => {
    return (
        <Modal open header={props.metric.metric_name}>
            <Text>{props.metric.last_poll_error_message}</Text>
            <div className={styles.metricModalButtons}>
                <Button variant="secondary" onClick={props.hideModal} fontAwesomeImage={ICON_CLOSE}>
                    Close
                </Button>
            </div>
        </Modal>
    );
};
